/**
 * LanguageToggle component - Language switch button
 * Uses public assets with fallback
 */
import React, { useState } from 'react';
import { useLanguage } from "../../hooks";
import * as styles from './languageToggle.css';

export const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const [isAnimating, setIsAnimating] = useState(false);

  // ================================
  // UTILITIES
  // ================================
  /**
   * Obtenir le drapeau à afficher (langue opposée)
   */
  const getCurrentFlagUrl = (): string => {
    const targetLanguage = language === 'fr' ? 'en' : 'fr';
    return targetLanguage === 'en' ? '/logos/UK.webp' : '/logos/FR.webp';
  };

  /**
   * Flag load error handler - désactiver les fallbacks pour éviter les 404
   */
  const handleFlagError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.warn('Erreur de chargement du drapeau:', e.currentTarget.src);
    // Masquer l'image en cas d'erreur au lieu de faire un fallback vers un asset inexistant
    e.currentTarget.style.display = 'none';
  };

  /**
   * Language change handler with animation
   */
  const handleLanguageChange = () => {
    if (isAnimating) return; // Avoid multiple clicks
    
    setIsAnimating(true);
    const newLanguage = language === 'fr' ? 'en' : 'fr';
    
    // Change language after a short delay for the animation
    setTimeout(() => {
      setLanguage(newLanguage);
      setIsAnimating(false);
    }, 250);
  };

  // ================================
  // RENDER
  // ================================
  
  return (
    <button 
      onClick={handleLanguageChange}
      className={`${styles.toggleButton} ${isAnimating ? styles.animating : ''}`}
      disabled={isAnimating}
      aria-label={`Switch to ${language === 'fr' ? 'English' : 'Français'}`}
      title={`Switch to ${language === 'fr' ? 'English' : 'Français'}`}
    >
  {/* Static flag */}
      <img 
        src={getCurrentFlagUrl()}
        alt={`Switch to ${language === 'fr' ? 'English' : 'Français'}`}
        className={styles.flagIcon}
        onError={handleFlagError}
        loading="lazy"
      />
      
  {/* Accessible text for screen readers */}
      <span className={styles.srOnly}>
        {language === 'fr' ? 'Changer en anglais' : 'Switch to French'}
      </span>
    </button>
  );
};

export default LanguageToggle;